import { useState, useEffect } from 'react'

const PaymentStatusModals = () => {
  const [showModal, setShowModal] = useState(false)
  const [modalType, setModalType] = useState(null)
  // Parse URL parameters from window.location
  const urlParams = new URLSearchParams(window.location.search)

  useEffect(() => {
    const status = urlParams.get('status')
    const payFor = urlParams.get('payFor')

    if (status && payFor) {
      setModalType(status)
      setShowModal(true)
    }
  }, [])

  const handleCloseModal = () => {
    setShowModal(false)
    setModalType(null)
    // Remove query parameters from URL
    const newUrl = window.location.pathname
    window.history.replaceState({}, document.title, newUrl)
  }

  function addPixelEvent() {
    const currentCourseId = '683c5e5d96470221a7610926'
    const productId = urlParams.get('productId')
    const payFor = urlParams.get('payFor')

    if (modalType === 'success' && payFor === 'course') {
      if (productId === currentCourseId) {
        // Small delay to ensure pixel is loaded
        setTimeout(() => {
          if (typeof fbq !== 'undefined') {
            fbq('track', 'Purchase')
            console.log('Facebook Pixel Purchase event tracked')
            return handleCloseModal()
          } else {
            console.warn('Facebook Pixel (fbq) not loaded')
            return handleCloseModal()
          }
        }, 100)
      }
    } else return handleCloseModal()
  }

  const handleBackdropClick = (e) => {
    // Close modal if clicking on the backdrop (not the modal content)
    if (e.target === e.currentTarget) {
      addPixelEvent()
    }
  }

  const handleTryAgain = () => {
    // Close modal and allow user to try payment again
    addPixelEvent()
    // You can add additional logic here like redirecting to payment page
  }

  if (!showModal) {
    return null
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}>
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-auto">
        {modalType === 'success' ? (
          // Success Modal
          <div className="p-6 text-center">
            {/* Success Icon */}
            <div className="flex justify-center mb-4">
              <img src="/TickModal.png" alt="Success" />
            </div>

            <h2 className="text-2xl font-bold text-blue mb-2">Thank You</h2>
            <p className="text-lg text-blue mb-6 font-bold">Purchase Complete Successfully</p>

            {/* Action Buttons */}

            <button
              onClick={() => addPixelEvent()}
              className="btn bg-transparent hover:bg-transparent text-black border-gray-800 w-full">
              Close
            </button>
          </div>
        ) : (
          // Error Modal
          <div className="p-6 text-center">
            {/* Error Icon */}
            <div className="flex justify-center mb-4">
              <img src="/ErrorModal.png" alt="Error" className="size-20" />
            </div>

            <h2 className="text-xl font-bold text-red mb-6">Something Went Wrong</h2>

            {/* Action Buttons */}

            <button onClick={handleTryAgain} className="btn bg-gray-800 ">
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default PaymentStatusModals
